// extracted by mini-css-extract-plugin
export default {"mediaButton":"index_mediaButton__sEYK0","iconWrapper":"index_iconWrapper__EYVj9","mediaButtonText":"index_mediaButtonText__9fSsW"};